export enum ECoHostStatus {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
  INVITATION_EXPIRED = 'INVITATION_EXPIRED',
  REMOVED = 'REMOVED',
}
